module.exports = __webpack_public_path__ + "media/images/ohap__Gradebook_Options_warning-e5d439e50c9aa103b64d71776b510a99.png";